/* eslint-disable no-param-reassign */
/* eslint-disable default-param-last */
import Line from './chartConfig/line.config'
import StackedBar from './chartConfig/stackedBar.config'
import Bar from './chartConfig/bar.config'
import GroupedBar from './chartConfig/groupedBar.config'
import WordCloud from './chartConfig/wordCloud.config'
import Pie from './chartConfig/pie.config'
import Geo from './chartConfig/geo.config'

const color = [
  '#6B88FF',
  '#5EB2FC',
  '#3FD2E0',
  '#5FE1A4',
  '#C7E677',
  '#FCD55E',
  '#FCB35E',
  '#FC985E',
  '#FC7272',
  '#F45A9A',
  '#DA5EFC',
  '#B45EFC',
  '#956EFC'
]

const config = {
  line: Line,
  stackedBar: StackedBar,
  bar: Bar,
  groupedBar: GroupedBar,
  wordCloud: WordCloud,
  pie: Pie,
  geo: Geo,
}

export default function getConfigByType(chartType, dataset, customConfig = {}, colors) {
  const newConfig = chartType ? config[chartType](dataset, colors || color) : {}
  assignDeep(newConfig, customConfig)
  return newConfig
}
function assignDeep(target, source) {
  for (const key in source) {
    // eslint-disable-next-line no-prototype-builtins
    if (source[key]?.toString() === '[object Object]' && target.hasOwnProperty(key)) {
      assignDeep(target[key], source[key])
    } else {
      target[key] = source[key]
    }
  }
  return target
}
